import { Routes } from '@angular/router';
import { MerchantSetupGuard } from '../core/guards/merchant-setup.guard';

export const onboardRoutes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'merchant' },
  {
    path: 'merchant',
    pathMatch: 'full',
    loadComponent: () => import('./setup-merchant-page/setup-merchant-page.component').then((m) => m.SetupMerchantPageComponent),
    canActivate: [MerchantSetupGuard],
  },
  {
    path: 'store/:slug',
    pathMatch: 'full',
    loadComponent: () => import('./setup-store-page/setup-store-page.component').then((m) => m.SetupStorePageComponent),
  },
];
